<template>
    <div
        v-if="balance && balanceTotal"
        class="stripe-balance-widget"
        v-loading="loading"
    >
        <div class="stripe-balance-widget__header">
            <app-i18n
                class="stripe-balance-widget__header__title"
                code="entities.wallet.balance.title"
            />
            <span class="stripe-balance-widget__header__amount">
                <app-i18n code="entities.wallet.balance.total" />
                <span v-text="' '" />
                <app-i18n-amount
                    class="stripe-balance-widget__header__amount__total"
                    :amount="balanceTotal.amount"
                    :currency="balanceTotal.currency"
                />
            </span>
        </div>
        <el-row
            class="stripe-balance-widget__row"
            justify="center"
            type="flex"
        >
            <el-col
                v-for="(stat, i) in balance"
                :key="`stripe-balance-widget__col--${i}`"
                :span="8"
            >
                <el-card
                    class="stripe-balance-widget__card"
                    :style="{ borderColor: stat.borderColor }"
                >
                    <el-tooltip
                        :content="stat.tooltipCaption"
                        placement="bottom"
                        class="stripe-balance-widget__card__tooltip"
                    >
                    <font-awesome-icon
                        :icon="tooltipIcon"
                        size="1x"
                    />
                    </el-tooltip>

                    <template v-if="!!stat">
                        <app-i18n-amount
                            :amount="stat.amount"
                            :currency="stat.currency"
                            class="stripe-balance-widget__card__amount"
                        />
                        <p
                            class="stripe-balance-widget__card__title"
                            v-text="stat.title"
                        />
                    </template>                    
                    <template v-else>
                        <p
                            class="stripe-balance-widget__card__title"
                            v-text="stat.emptyCaption"
                        />
                    </template>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

export default {
    name: 'app-stripe-balance-widget',
    props: {
        subpropertyId: {
            type: String,
            required: true,
        }
    },  
    data() {
        return {
            tooltipIcon: faQuestionCircle
        };
    },
    computed: {
        ...mapGetters({
            balance: 'stripeBalance/list/balance',
            balanceTotal: 'stripeBalance/list/balanceTotal',
            loading: 'stripeBalance/list/loading',
        }),
    },
    methods: {
        ...mapActions({
            doFetch: 'stripeBalance/list/doFetch'
        }),  
    },
    created() {
        this.doFetch({subpropertyId: this.subpropertyId});
    }, 
}
</script>

<style lang="scss" scoped>
.stripe-balance-widget {
    &__header {
        display: flex;
        justify-content: space-between;
        color: #404040;
        font-size: 18px;
        font-weight: 400;

        &__amount {
            &__total {
                font-weight: bold;
            }
        }

        &__title {
            padding: 0 0 24px;
            font-size: 18px;
            font-weight: normal;
            line-height: 1.11;
            letter-spacing: normal;
        }
    }

    &__row {
        width: 100%;
        flex-wrap: wrap;
    }

    &__card {
        border: 0;
        border-bottom: 3px solid transparent;
        border-radius: 0;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        height: 140px;
        margin: 6px;

        &__tooltip {
            grid-area: tooltip;
        }

        &__title {
            grid-area: title;
            font-size: 14px;
            font-weight: 300;
            text-align: center;
            color: rgba(64, 64, 64, 0.35);
            margin: 8px 0;
        }

        &__amount {
            grid-area: amount;
            font-size: 30px;
            font-size: 2.2vw;
            font-weight: 500;
            letter-spacing: -0.8px;
            text-align: center;
        }
    }
}
</style>

<style lang="scss">
.stripe-balance-widget {
    &__card {
        .el-card__body {
            display: grid;
            grid-template-columns: 20px 1fr 20px;
            grid-template-rows: 35px 35px 0px;
            grid-template-areas:
                'arrow . tooltip'
                'amount amount amount'
                'title title title';
            padding: 10px;
        }
    }
}
</style>